module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manager-track-report center-panel report"
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.dealsAmount,
      "table-id": "report",
      "default-order": "desc",
      "default-sort": "id",
      "showAddButton": false
    },
    on: {
      "refresh": _vm.getDeals
    },
    scopedSlots: _vm._u([{
      key: "first_freight",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" " + _vm._s((scope.item.first_freight && scope.item.first_freight.traking_number) ? scope.item.first_freight.traking_number : 'Не установлен') + " ")])]
      }
    }, {
      key: "created_at",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" " + _vm._s((scope.item.created_at && scope.item.created_at) ? _vm.moment(scope.item.created_at).format('DD MMM YYYY') : 'Не установлен') + " ")])]
      }
    }, {
      key: "from_stock",
      fn: function(scope) {
        return [(scope.item.from_address && scope.item.from_address.address) ? _c('span', [_vm._v(" " + _vm._s(scope.item.from_address.address) + " ")]) : _vm._e(), _vm._v(" "), (scope.item.from_stock && scope.item.from_stock.name) ? _c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" " + _vm._s(scope.item.from_stock.name) + " ")]) : _vm._e(), _vm._v(" "), (!scope.item.from_address && !scope.item.from_stock) ? _c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" Не указан ")]) : _vm._e()]
      }
    }, {
      key: "to_stock",
      fn: function(scope) {
        return [(scope.item.to_address && scope.item.to_address.address) ? _c('span', [_vm._v(" " + _vm._s(scope.item.to_address.address) + " ")]) : _vm._e(), _vm._v(" "), (scope.item.to_stock && scope.item.to_stock.name) ? _c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" " + _vm._s(scope.item.to_stock.name) + " ")]) : _vm._e(), _vm._v(" "), (!scope.item.to_address && !scope.item.to_stock) ? _c('span', {
          staticClass: "no-break-text"
        }, [_vm._v(" Не указан ")]) : _vm._e()]
      }
    }, {
      key: "payer",
      fn: function(scope) {
        return [(scope.item.payer && scope.item.payer.name) ? _c('span', [_vm._v(" " + _vm._s(scope.item.payer.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "executor",
      fn: function(scope) {
        return [(scope.item.executor && scope.item.executor.name) ? _c('span', [_vm._v(" " + _vm._s(scope.item.executor.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "payment_type",
      fn: function(scope) {
        return [_c('span')]
      }
    }, {
      key: "credit",
      fn: function(scope) {
        return [_c('span')]
      }
    }]),
    model: {
      value: (_vm.deals),
      callback: function($$v) {
        _vm.deals = $$v
      },
      expression: "deals"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776b394a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/PaymentReport.vue
// module id = 1199
// module chunks = 0